import { gql } from '@apollo/client'
import { PACKAGING_FRAGMENT } from './PackagingFragment'
import { SHIPPING_FRAGMENT } from './ShippingFragment'

export const SIMPLE_PRODUCT_FRAGMENT = gql`
  fragment SimpleProduct on Product {
    id
    upcA
    upcE
    name
    commonName
    isActive
    brand {
      id
      name
    }
    manufacturer {
      id
      name
    }
    marketingImageUrl
    packaging {
      ...Packaging
    }
    shipping {
      ...Shipping
    }
    flavors {
      id
      flavor
      displayFlavor
    }
    companyCategory {
      id
      category
      parentCategory
    }
    geometry {
      id
      geometry
    }
    verifiedBy
    images {
      url
      id
      bucketFileName
    }
  }
  ${PACKAGING_FRAGMENT}
  ${SHIPPING_FRAGMENT}
`
